<script setup lang="ts">
import { CHART_ENGINE } from '@/shared/lib'

import AmChartsAreaChart from './AmChartsAreaChart.vue'
import ChartJsAreaChart from './ChartJsAreaChart.vue'
import type { AreaChartProps } from './types'

/**
 * One value over time, drawn as a filled line on a **date** axis — a single daily figure
 * whose shape matters more than its exact buckets.
 *
 * `LineChart` and not this one for several metrics at once; `ColumnChart` for a value per
 * labelled bucket where a single day still has to read as something.
 *
 * The value axis starts at zero. `signed` is for a figure that can fall below it (a
 * return, a balance change): the axis then follows the data but always takes zero in, with
 * the zero line drawn heavier, a positive value reads with a `+` in the tooltip, and the
 * stretch under zero is drawn in `--el-color-danger`, tooltip included.
 *
 * Drawn by Chart.js or amCharts, whichever `CHART_ENGINE` names; until one of them goes, a
 * change of behaviour is made in both `ChartJsAreaChart.vue` and `AmChartsAreaChart.vue`.
 */
defineProps<AreaChartProps>()

const engine =
  CHART_ENGINE === 'amcharts' ? AmChartsAreaChart : ChartJsAreaChart
</script>

<template>
  <component :is="engine" v-bind="$props" />
</template>
